import { render, staticRenderFns } from "./RessifnetMapping.vue?vue&type=template&id=4e3968c3&"
import script from "./RessifnetMapping.vue?vue&type=script&lang=ts&"
export * from "./RessifnetMapping.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports